import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text4, Text6 } from "@churchofjesuschrist/eden-text";
import { spacing4, spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-169bs0j-0"
})(["max-width:512px;max-height:120px;padding:", " 0;margin:auto;"], spacing16);
const CaptionText = styled.div.withConfig({
  componentId: "sc-169bs0j-1"
})(["padding-block-end:", ";"], spacing16);
const Attribution = styled.div.withConfig({
  componentId: "sc-169bs0j-2"
})([""]);
const ModalTitle = styled.strong.withConfig({
  componentId: "sc-169bs0j-3"
})(["padding-inline-end:", ";"], spacing4);
const Caption = _ref => {
  let {
    title,
    caption,
    attribution
  } = _ref;
  return /*#__PURE__*/_jsxs(Container, {
    children: [caption && /*#__PURE__*/_jsx(CaptionText, {
      children: /*#__PURE__*/_jsxs(Text4, {
        children: [title && /*#__PURE__*/_jsx(ModalTitle, {
          children: title
        }), caption]
      })
    }), attribution && /*#__PURE__*/_jsx(Attribution, {
      children: /*#__PURE__*/_jsx(Text6, {
        children: attribution
      })
    })]
  });
};
Caption.propTypes = {
  /** Media Title */
  title: PropTypes.string,
  /** Media Caption */
  caption: PropTypes.node,
  /** Media Attribution */
  attribution: PropTypes.node
};
export default Caption;